import { RootState } from "redux/rootReducer";

export const selectIsLoadingDefaultSetting = (state: RootState) =>
  state.defaultSetting.loading;
export const selectDefaultSettingErrorMessage = (state: RootState) =>
  state.defaultSetting.error;
export const defaultSettingDataResponse = (state: RootState) =>
  state.defaultSetting.defaultSettingResponse;
